<script setup lang="ts">
import { ECommandPalette, type Command } from '@erpx/ui'

import { useCommands } from '@/composables/useCommands'
import { useOverlays } from '@/composables/useOverlays'

/**
 * Mounts the ⌘K palette and connects it to the app's command set. The palette
 * component filters and renders; deciding what a command *does* stays in
 * `useCommands`, where the permission checks already are.
 */

const overlays = useOverlays()
const { commands, run } = useCommands()

function onSelect(command: Command): void {
  run(command)
}
</script>

<template>
  <ECommandPalette
    v-model:open="overlays.paletteOpen.value"
    :commands="commands"
    :placeholder="$t('palette.placeholder')"
    :empty-text="$t('palette.empty')"
    @select="onSelect"
  />
</template>
